import { useKeycloak } from "@react-keycloak/web";
import LogoMJVIron from '../../../assets/img/logo-mjv-iron.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function LockedPage() {
  const [activeButton, isActiveButton] = useState(true);
  const { keycloak } = useKeycloak();
  const tokenParsed = keycloak.tokenParsed;
  const authUrl = process.env.REACT_APP_AUTH_API_URL;


  // TODO: Padronizar o uso de axios para requisições
  const savePlan = async (e, plan) => {
    e.preventDefault();
    isActiveButton(false);
    try {
      const userEmail = tokenParsed.email;
      const fullName = tokenParsed.given_name + ' ' + tokenParsed.family_name;
      const userName = tokenParsed.preferred_username;
      var totalSpendTokens = tokenParsed.totalSpendTokens;
      const accessToken = keycloak.token;

      totalSpendTokens = parseInt(totalSpendTokens, 10); 
      if (isNaN(totalSpendTokens) || totalSpendTokens <= 0) {
        totalSpendTokens = 1; 
      }
  
      const bodyData = {
        planName: plan,
        userEmail,
        fullName,
        userName,
        totalSpendTokens,
      };

      const response = await fetch(`${authUrl}/leads/newLead`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(bodyData),
      });
  
      if (!response.ok) {
        throw new Error('Erro ao salvar o Lead. Tente novamente mais tarde.');
      }
  
      const data = await response.json();
      
      if (data.success) {
        const mailtoLink = `mailto:ricardo.sepulveda@mjv.com.br?subject=Upgrade de Plano&body=Olá Ricardo, gostaria de saber mais sobre o plano ${plan}.%0D%0A%0D%0AUsuário: ${userName}%0D%0ANome: ${fullName}%0D%0AEmail: ${userEmail}%0D%0ATotal de Tokens: ${totalSpendTokens}`;
        window.location.href = mailtoLink;
      } else {
        throw new Error('Erro ao criar o Lead: ' + (data.message || 'Desconhecido'));
      }
    } catch (error) {
      console.error('Erro ao salvar Lead:', error);
    }
  };  

  return(
        <section className="bsb-pricing-3 py-5 py-xl-8">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-12 col-md-10 col-lg-8 col-xl-7 text-center">
                <img src={LogoMJVIron} width="150" className="mb-5" alt="MJV Iron Logo" />
                <h2 className="display-5 mb-5 mb-xl-9 text-center">A sua licença gratuita expirou, que tal conhecer um de nossos planos?</h2>
              </div>
            </div>
          </div>
            <div className="container my-5">
                <div className="row">
                    <div className="col-md-3">
                        <div className="card border-primary mb-4">
                            <div className="card-header text-center bg-primary text-white">
                                <h4>Bronze</h4>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <li className="list-group-item text-center"><small>Licenças:</small><br/> <strong>pelo menos 20 usuários</strong></li>
                                    <li className="list-group-item text-center"><small>Agentes:</small><br/> <strong>9 agentes</strong></li>
                                    <li className="list-group-item text-center"><small>Canal de Suporte:</small><br/> <strong>ticket</strong></li>
                                    <li className="list-group-item text-center"><small>Suporte Técnico:</small><br/> <strong>8x5</strong></li>
                                    <li className="list-group-item text-center"><small>Treinamento:</small><br/> <strong>vídeos gravados</strong></li>
                                    <li className="list-group-item text-center"><small>Infraestrutura Dedicada:</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>LLM Privado:</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>Múltiplos LLMs (*):</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>On Premise:</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>Especialista em Sucesso do Cliente:</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center">Valores e Taxas:<br/>
                                        <button 
                                            className="btn btn-primary mt-2"
                                            onClick={(e) => savePlan(e, 'bronze')}
                                            disabled={!activeButton}
                                        >
                                            Entre em Contato
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-secondary mb-4">
                            <div className="card-header text-center bg-secondary text-white">
                                <h4>Silver</h4>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <li className="list-group-item text-center"><small>Licenças:</small><br/> <strong>pelo menos 30 usuários</strong></li>
                                    <li className="list-group-item text-center"><small>Agentes:</small><br/> <strong>11 agentes + customizado</strong></li>
                                    <li className="list-group-item text-center"><small>Canal de Suporte:</small><br/> <strong>ticket / linha direta</strong></li>
                                    <li className="list-group-item text-center"><small>Suporte Técnico:</small><br/> <strong>8x5</strong></li>
                                    <li className="list-group-item text-center"><small>Treinamento:</small><br/> <strong>vídeos gravados + 2 horas online/mês</strong></li>
                                    <li className="list-group-item text-center"><small>Infraestrutura Dedicada:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>LLM Privado:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>Múltiplos LLMs (*):</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>On Premise:</small><br/> <strong><FontAwesomeIcon icon={faClose} /></strong></li>
                                    <li className="list-group-item text-center"><small>Especialista em Sucesso do Cliente:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center">Valores e Taxas:<br/> 
                                        <button 
                                            className="btn btn-primary mt-2"
                                            onClick={(e) => savePlan(e, 'silver')}
                                            disabled={!activeButton}
                                        >
                                            Entre em Contato
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-warning mb-4">
                            <div className="card-header text-center bg-warning text-white">
                                <h4>Golden</h4>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <li className="list-group-item text-center"><small>Licenças:</small><br/> <strong>pelo menos 120 usuários</strong></li>
                                    <li className="list-group-item text-center"><small>Agentes:</small><br/> <strong>11 agentes + customizado</strong></li>
                                    <li className="list-group-item text-center"><small>Canal de Suporte:</small><br/> <strong>ticket / linha direta</strong></li>
                                    <li className="list-group-item text-center"><small>Suporte Técnico:</small><br/> <strong>8x6</strong></li>
                                    <li className="list-group-item text-center"><small>Treinamento:</small><br/> <strong>vídeos gravados + 5 horas online/mês</strong></li>
                                    <li className="list-group-item text-center"><small>Infraestrutura Dedicada:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>LLM Privado:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>Múltiplos LLMs (*):</small><br/> <strong>possível</strong></li>
                                    <li className="list-group-item text-center"><small>On Premise:</small><br/> <strong>possível</strong></li>
                                    <li className="list-group-item text-center"><small>Especialista em Sucesso do Cliente:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center">Valores e Taxas:<br/>
                                        <button 
                                            className="btn btn-primary mt-2"
                                            onClick={(e) => savePlan(e, 'golden')}
                                            disabled={!activeButton}
                                        >
                                            Entre em Contato
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card border-danger mb-4">
                            <div className="card-header text-center bg-danger text-white">
                                <h4>Diamond</h4>
                            </div>
                            <div className="card-body">
                                <ul className="list-group">
                                    <li className="list-group-item text-center"><small>Licenças:</small><br/> <strong>pelo menos 280 usuários</strong></li>
                                    <li className="list-group-item text-center"><small>Agentes:</small><br/> <strong>9 agentes básicos + customizado</strong></li>
                                    <li className="list-group-item text-center"><small>Canal de Suporte:</small><br/> <strong>customizado</strong></li>
                                    <li className="list-group-item text-center"><small>Suporte Técnico:</small><br/> <strong>customizado</strong></li>
                                    <li className="list-group-item text-center"><small>Treinamento:</small><br/> <strong>online / presencial</strong></li>
                                    <li className="list-group-item text-center"><small>Infraestrutura Dedicada:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>LLM Privado:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center"><small>Múltiplos LLMs (*):</small><br/> <strong>possível</strong></li>
                                    <li className="list-group-item text-center"><small>On Premise:</small><br/> <strong>possível</strong></li>
                                    <li className="list-group-item text-center"><small>Especialista em Sucesso do Cliente:</small><br/> <strong><FontAwesomeIcon icon={faCheck} /></strong></li>
                                    <li className="list-group-item text-center">Valores e Taxas:<br/>
                                        <button 
                                            className="btn btn-primary mt-2"
                                            onClick={(e) => savePlan(e, 'diamond')}
                                            disabled={!activeButton}
                                        >
                                            Entre em Contato
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-5" style={{color: 'Red'}}>
                    <span>Cada plano possuí diferenças quanto às taxas por licensa, configuração e adicionais. Entre em contato para mais detalhes.</span>
                </div>
                <div className="text-center">
                    <button className="btn btn-primary mt-3" onClick={() => keycloak.logout()}>
                        Sair do Sistema
                    </button>
                </div>
            </div>
        </section>
  );
}
